const topLifestyle = (() => {
  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {

    let sW = window.innerWidth;

    let centeredSlides;
    let slidesPerView;
    let spaceBetween;

    if (sW > 750) {
      centeredSlides = false
      slidesPerView = 3.3
      spaceBetween = 10
    } else {
      centeredSlides = true
      slidesPerView = 1.3
      spaceBetween = 20
    }


    const swiper = new Swiper("#jsSwiperLifestyle", {
      centeredSlides: centeredSlides,
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      speed: 800,
      // freeModeMomentumBounce: true,
      // momentumBounce: false,
      // resistance: true,
      navigation: {
        nextEl: ".slide-btn-next",
        prevEl: ".slide-btn-prev"
      }
    });


  }
})();
export default topLifestyle;